import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { logger } from 'redux-logger';
import { rootReducer } from './root-reducer';

import { api } from '../api/rtk';                // <-- add
import { setupListeners } from '@reduxjs/toolkit/query'; // <-- add

// (optional) pull in redux-persist action constants to silence serializable warnings cleanly
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

// Transform to ensure system reducer fields are properly handled
const systemTransform = createTransform(
  // Transform state on its way to being serialized and persisted
  (inboundState, key) => {
    return inboundState;
  },
  // Transform state being rehydrated
  (outboundState, key) => {
    // Ensure default values are set if they're missing
    if (outboundState && key === 'system') {
      return {
        ...outboundState,
        checklistSportDefault: outboundState.checklistSportDefault || "MLB",
        checklistYearDefault: outboundState.checklistYearDefault || "2025",
        checklistManufacturerDefault: outboundState.checklistManufacturerDefault || "Topps"
      };
    }
    return outboundState;
  },
  // Which reducers this transform should run on
  { whitelist: ['system'] }
);

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [],
  // Note: RTK Query cache (api.reducerPath) is intentionally NOT persisted
  whitelist: ['system', 'user'], // Explicitly whitelist system and user reducers
  transforms: [systemTransform]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middleWares = [api.middleware];

if (process.env.NODE_ENV !== 'production') {
  middleWares.push(logger);
}

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      // Ignore these action types
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      // Ignore these field paths in all actions
      ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
      // Ignore these paths in the state
      ignoredPaths: [
        'register', 
        'showcase.cardsById.*.createdAt',
        'showcase.cardsById.*.updatedAt',
        'api.queries.*.data.*.listingDate',
        'api.queries.*.data.*.saleDate',
        'api.queries.*.data.*.createdAt',
        'api.queries.*.data.*.updatedAt'
      ],
    },
  }).concat(middleWares),
});

export const persistor = persistStore(store);
setupListeners(store.dispatch);